// extracted by mini-css-extract-plugin
export default {"btnpwd":"f216bcd850"};